export default __webpack_public_path__ + "static/media/dx_071103.cd0d2460.png";